import React, { HTMLAttributes, ReactElement, ReactNode, memo } from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding: 15px 60px;
    margin-right: auto;
    margin-left: auto;
    background-color: #ffffff;
    border: none;
    width: 100%;
    max-width: 1400px;

    @media (max-width: 990px) {
        padding: 15px 20px;
    }
`

export type PageLayoutContainerProps = {
    children: ReactNode
} & HTMLAttributes<HTMLDivElement>

export const PageLayoutContainer = memo(function PageLayoutContainer({
    children,
    ...props
}: PageLayoutContainerProps): ReactElement {
    return <Wrapper {...props}>{children}</Wrapper>
})
